import axios from '@/axios';

/**
 * 병원검색 role별 제외 키워드 관리 API
 */
const HospitalSearchKeywordApi = {
  /**
   * 제외 키워드 목록 조회
   * @param {string} [role] - HOSPITAL | MANUFACTURER | CUSTOMER (미지정 시 전체)
   * @returns {Promise}
   */
  getList(role) {
    return axios.get('/admin/hospital-search-keywords', {
      params: role ? { role } : {},
    });
  },

  /**
   * 제외 키워드 등록
   * @param {Object} data
   * @param {string} data.role - HOSPITAL | MANUFACTURER | CUSTOMER
   * @param {string} data.keyword - 제외 키워드
   * @returns {Promise}
   */
  create(data) {
    return axios.post('/admin/hospital-search-keywords', data);
  },

  /**
   * 제외 키워드 삭제
   * @param {string} id - 키워드 문서 ID
   * @returns {Promise}
   */
  remove(id) {
    return axios.delete(`/admin/hospital-search-keywords/${id}`);
  },
};

export default HospitalSearchKeywordApi;
